<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div class="row">
            <div class="col-12">
                <TitleComponent title="2. Tus abonos" subtitle="Completa la información necesaria para cada uno de los abonos seleccionados"/>
            </div>
            <div class="col-12 mb-3">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" v-model="select_all" id="select_all" :disabled="disabled || datosCompradoresEnviados"/>
                    <label class="custom-control-label" for="select_all">Seleccionar todos los abonos</label>
                </div>
            </div>
            <div class="col-12 mb-3">
                <Button @click.prevent="volver">Cambiar butacas</Button>
            </div>
            <div class="col-12">
                <div class="row" id="datos-abonos">
                    <template v-for="(abono, index) in datos_de_compradores">
                        <b-col lg="4" md="6" sm="12" :key="index">
                            <DatosAbonoComponent
                                v-if="loading != index"
                                :area="abono.area"
                                :abono="abono"
                                :generos="generos"
                                :index="index"
                                :precios="zona_precios"
                                :zona="zona"
                                v-on:actualizado="actualizar(index)"
                                v-on:borrar="borrar(index)"
                                @setDatosAbono="setDatosAbono"
                                :desactivar="desactivar || datosCompradoresEnviados"
                                :validator="$refs.observer"
                                @isValidNumber="validarTelefono"
                            />
                        </b-col>
                    </template>

                </div>
            </div>
            <div v-if="!datosCompradoresEnviados" class="col-12 mt-4 mb-3">
                <b-button type="submit" data-cy="guardar-datos">Continuar</b-button>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-end pb-4">
                <Button v-if="datosCompradoresEnviados" @click="modificarDatos" :disabled="((parcelasCompradas && teatro.hash !== 'J1fKG9AarPuPNJ5hwY0t') || disabled)">Modificar datos</Button>
            </div>
            <div class="col-12 mb-4 p-0" id="pregunta-parcelas" v-if="datosCompradoresEnviados && listaAbonados.activar_parcelas && footer.activar_parcelas && !continuar && !parcelas && teatro.hash !== 'J1fKG9AarPuPNJ5hwY0t'">
                <TitleComponent class="col-12 col-md-10" title="¿Quieres comprar parcelas?" subtitle="Además de tus abonos, puedes comprar parcelas del terreno de juego para disfrutar de una experiencia completa y la posibilidad de ganar un premio."/>
                <div class="col-12">
                    <Button type="button" @click="quieresComprarParcelas()" class="mt-2 mr-3" :disabled="disabled">{{ $t("nuevo_abono.si_quiero") }}</Button>
                    <Button type="button" @click="sinParcelas()" class="mt-2" :disabled="disabled">no, continuar</Button>
                </div>
            </div>
            <template v-if="parcelas && teatro.hash !== 'J1fKG9AarPuPNJ5hwY0t'">
                <div>
                    <VentaParcelasAbonos :datos_compradores="datos_compradores" :session_butaca_data="session_butaca_data" :session_id="session_id" @finalizarCompraParcelas="terminarPasoParcelas()"/>
                </div>
                <div class="col-12 d-flex justify-content-end">
                    <button class="btn btn-primary" @click="cancelarCompraParcelas" :disabled="disabled">
                        <span>cancelar compra {{ teatro.hash === 'J1fKG9AarPuPNJ5hwY0t' ? 'terrenos' : 'parcelas' }}</span>
                    </button>
                </div>
            </template>
            <template v-if="continuar && datosCompradoresEnviados">
                <div class="col-12 d-flex justify-content-end" v-if="teatro.hash !== 'J1fKG9AarPuPNJ5hwY0t'">
                    <Button v-if="listaAbonados.activar_parcelas && footer.activar_parcelas && !parcelasCompradas" @click="quieresComprarParcelas()" :disabled="disabled">comprar parcelas</Button>
                </div>
                <div class="col-12">
                    <TitleComponent title="3. Finalizar compra" subtitle="Selecciona un método de pago, descuento y finaliza tu compra"/>
                </div>
                <div class="col-12" id="finalizar-compra">
                    <div class="mb-3">
                        <AddPlazosComponent
                            v-if="compraConPlazos"
                            :frecuencias="frecuencias"
                            :min_plazos="min_plazos"
                            :max_plazos="max_plazos"
                            :gastos="datos_de_compradores[0].precio.price_management"
                            :tiene_gastos="datos_de_compradores[0].precio.price_management_interno ? false : true"
                            :error_plazos="error_plazos"
                            :compraConPlazos="compraConPlazos"
                            :datos_compradores="datos_compradores"
                            :key="reload"
                            :plazosSeleccionados="plazosSeleccionados"
                            :disabled="disabled"
                            @plazosSeleccionados="(tienePlazosSeleccionados) => { plazosSeleccionados = tienePlazosSeleccionados }"
                            @terminado="solicitarPlazos"
                            @reset="resetPlazos"
                        />
                    </div>
                    <div class="form-group">
                        <label for="metodo_pago">Método de pago</label>
                        <ValidationProvider name="metodo_pago" rules="required" v-slot="{ errors }">
                            <multiselect
                                v-if="metodos_pago"
                                id="metodo_pago"
                                v-model="datos_compra.metodo_pago"
                                placeholder="Método de pago"
                                label="nombre"
                                :multiple="permitirVariosMetodosPago"
                                :options="metodos_pago"
                                :class="(errors[0] ? 'is-invalid' : '')"
                                @select="setMetodosDePago"
                                @remove="deleteMetodoDePago"
                                :disabled="disabled"
                                trackBy="id"
                            />
                        </ValidationProvider>
                    </div>
                    <template v-if="datos_compra.metodo_pago != null && datos_compra.metodo_pago.valor == 9">
                        <FormInput label="IBAN" name="IBAN" rules="required" v-model="datos_compra.iban" />
                        <FormInput label="Titular de la cuenta" name="Titular de la cuenta" rules="required" v-model="datos_compra.titular_cuenta" />
                    </template>
                </div>
                <b-col
                    v-if="show_desglose && datos_compra.metodo_pago && datos_compra.metodo_pago.length > 1"
                    cols="12"
                >
                    <b-row>
                        <template v-for="(abono, index) in datos_de_compradores" >
                            <DesgloseMetodoPagoAbono
                                v-if="abono.precio"
                                :abono="abono"
                                :key="index"
                                :importe="abono.precio.precio_total_taquilla"
                                :descuento_aplicado="parseFloat(abono.descuento_aplicado)"
                                :descuento_integro="parseFloat(abono.descuento_integro)"
                                :metodos_pago="abono.metodo_pago"
                                :numero="++index"
                                @error="(error) => { abono.error = error }"
                                @valido="fillMetodosPago"
                                :disabled="disabled"
                            />
                        </template>
                    </b-row>
                </b-col>
                <div class="col-12">
                    <Button
                        id="continuar-paso3"
                        type="submit"
                        class="btn-block"
                        :disabled="disabled"
                    >
                        CONTINUAR COMPRA
                    </Button>
                </div>
            </template>
        </div>
    </ValidationObserver>
</template>

<script>
    import TitleComponent from '@/components/backend/stepper/components/TitleComponent';
    import DatosAbonoComponent from '@/components/backend/stepper/components/DatosAbonoComponent';
    import DesgloseMetodoPagoAbono from '../components/DesgloseMetodoPagoAbono.vue';
    import AddPlazosComponent from '../components/plazos/AddPlazosComponent';
    import VentaParcelasAbonos from '@/components/backend/stepper/abonos/components/VentaParcelasAbonos.vue';

    export default {
        props: ['datos_compradores', 'precios', 'zona', 'disabled', 'session_butaca_data', 'session_id'],
        data() {
            return {
                datos_compra: {
                    concepto: '',
                    metodo_pago: null,
                    modalidad: 0,
                    tipo: false,
                },
                metodos_pago: null,
                metodos_pago_formatted: [],
                select_all: false,
                loading: 999,
                zona_precios: null,
                desactivar: false,
                datos_de_compradores: this.datos_compradores,
                show_desglose: false,
                isValidNumber: [],
                min_plazos: null,
                max_plazos: null,
                frecuencias: null,
                error_plazos: false,
                plazosSeleccionados: false,
                reload: 1,
                datosCompradoresEnviados: false,
                parcelas: false,
                continuar: false,
                formularioDatos: false,
                parcelasCompradas: false
            }
        },
        created() {
            this.metodos_pago = this.teatro.metodos_pago_abonos_bases.slice().filter(metodo_pago => metodo_pago.show_taquilla);

            for(var i in this.datos_de_compradores) {
                if(this.datos_de_compradores[i].area) {
                    this.datos_de_compradores[i].area.unidades = 0;
                }
                if (!this.datos_de_compradores[i].plaza) {
                    this.datos_de_compradores[i].plaza = {};
                }
            }

            this.getTipoAbonoPrecio();
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            tienenPrecio() {
                let precio = true;

                Object.values(this.datos_de_compradores).forEach(abono => {
                    if(abono.precio == undefined) {
                        precio = false;
                    }
                })

                return precio;
            },
            permitirVariosMetodosPago() {
                let price_management_interno = 1;
                Object.values(this.datos_de_compradores).forEach(abono => {
                    if(abono.precio && abono.precio.price_management_interno == 0) {
                        price_management_interno = 0;
                    }
                })

                return price_management_interno == 0 ? false : true;
            },
            compraConPlazos() {
                const datos = Object.values(this.datos_de_compradores);
                return this.teatro.permitir_plazos_abonados && datos.every(abono => abono.area && abono.area.activar_pago_plazos);
            },
            listaAbonados() {
                return this.$store.getters.getListaAbonados;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            generos() {
                return this.$store.getters.getGeneros;
            }
        },
        methods: {
            scrollTo(paso) {
                this.$scrollTo(paso, 100)
            },
            goTo(paso) {
                if (this.metodos_pago_formatted.length > 1) {
                    this.datos_compra.metodo_pago = this.metodos_pago_formatted;
                }
                this.$emit('goTo', paso, this.datos_compra);
            },
            validarTelefono({ index, valid }) {
                this.$set(this.isValidNumber, index, valid);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                const allPhonesValid = this.isValidNumber.every(valid => valid);

                if(isValid && allPhonesValid && !this.datosCompradoresEnviados) {
                    this.enviarDatosCompradores();
                    if (this.teatro.hash === 'J1fKG9AarPuPNJ5hwY0t') {
                        this.continuar = true;
                    } else {
                        if(!this.listaAbonados.activar_parcelas || !this.footer.activar_parcelas) {
                            this.continuar = true;
                        } else {
                            setTimeout(() => {
                                this.$scrollTo('#pregunta-parcelas', 500);
                            }, 500);
                        }
                    }
                }
                if(isValid && allPhonesValid && this.datosCompradoresEnviados) {
                    if(this.datos_compra.metodo_pago.length > 1) {
                        let error = false;

                        Object.values(this.datos_de_compradores).forEach(abono => {
                            if(abono.error) {
                                error = true;
                            }
                        });

                        if(! error) {
                            this.desactivar = true;
                            this.goTo(4);
                        }
                    } else {
                        this.desactivar = true;
                        this.goTo(4);
                    }
                }
                else {
                    this.$nextTick(function() {
                        this.scrollTo('.is-invalid');
                    });
                }
            },
            actualizar(index) {
                if(this.select_all && index == 0) {
                    for(var i in this.datos_de_compradores) {
                        var datos = Object.assign({}, this.datos_de_compradores[index]);
                        var asiento = Object.assign({}, this.datos_de_compradores[i].asiento);
                        var plaza = Object.assign({}, this.datos_de_compradores[i].plaza);
                        datos.lista_abonado_sesion_id = this.datos_de_compradores[i].lista_abonado_sesion_id;
                        this.datos_de_compradores[i] = datos;
                        this.datos_de_compradores[i].asiento = asiento;
                        this.datos_de_compradores[i].plaza = plaza;
                        this.loading = i;
                    }
                } else {
                    var datos2 = Object.assign({}, this.datos_de_compradores[index]);
                    var asiento2 = Object.assign({}, this.datos_de_compradores[index].asiento);
                    var plaza2 = Object.assign({}, this.datos_de_compradores[index].plaza);
                    datos2.lista_abonado_sesion_id = this.datos_de_compradores[index].lista_abonado_sesion_id;
                    this.datos_de_compradores[index] = datos2;
                    this.datos_de_compradores[index].asiento = asiento2;
                    this.datos_de_compradores[index].plaza = plaza2;
                    this.loading = index;
                }
                this.loading = 999;

                if (this.compraConPlazos) {
                    this.setConfigPlazos();
                }
            },
            async borrar(index) {
                const borrado = await this.deleteSession(this.datos_de_compradores[index].lista_abonado_sesion_id);

                if(!borrado) {
                    this.$toast.error('Error al eliminar la sesión del abono');
                    return;
                }

                delete this.datos_de_compradores[index];

                var tempDatos = {};
                var orderedIndex = 0;
                for(const i in this.datos_de_compradores) {
                    tempDatos[orderedIndex] = this.datos_de_compradores[i];
                    orderedIndex++;
                }

                this.datos_de_compradores = tempDatos;
                if (Object.keys(this.datos_de_compradores).length === 0) {
                    this.volver();
                }
                this.$emit("actualizar", this.datos_de_compradores);
            },
            deleteSession(lista_abonado_sesion_id)  {
                return new Promise(resolve => {
                    const params = {
                        session_id: lista_abonado_sesion_id,
                        lista_id: this.$store.getters.getListaId
                    };
                    this.$store.dispatch(this.config.getVuexAlias('back.abonos.taquilla.delete.session'), params)
                        .then(res => {
                            this.$toast.success('Abono eliminado correctamente');
                            resolve(true);
                        })
                        .catch(error => {
                            resolve(false);
                        });
                });
            },
            volver() {
                this.$emit('volver');
            },
            getTipoAbonoPrecio() {
                const params = {
                    filters: {
                        zona_id: this.zona.id
                    },
                    zona_id: this.zona.id
                };
                this.$store.dispatch(this.config.getVuexAlias('back.zonas.precios'), params).then(res => {
                    this.zona_precios = res.data.data;
                });
            },
            setMetodosDePago(selected, id) {
                this.show_desglose = false;
                if(this.permitirVariosMetodosPago) {
                    Object.values(this.datos_de_compradores).forEach((abono, index) => {
                        if(abono.metodo_pago === undefined) {
                            abono.metodo_pago = [];
                        }

                        const nuevoMetodoPago = Object.assign({}, selected);

                        if(this.session_butaca_data[index]) {
                            nuevoMetodoPago.lista_abonado_sesion_id = this.session_butaca_data[index].id;
                        } else {
                            nuevoMetodoPago.lista_abonado_sesion_id = [];
                        }

                        abono.metodo_pago.push(nuevoMetodoPago);

                        if(abono.metodo_pago.length == 1) {
                            abono.metodo_pago[0].importe = abono.precio.precio_total_taquilla;
                        }
                    })

                    this.$emit("actualizar", this.datos_de_compradores);
                }
                this.$nextTick(() => {
                    this.show_desglose = true;
                })
            },
            deleteMetodoDePago(deleted, id) {
                this.show_desglose = false;
                Object.values(this.datos_de_compradores).forEach(abono => {
                    if (abono.metodo_pago) {
                        for (let index = 0; index < abono.metodo_pago.length; index++) {
                            if(abono.metodo_pago[index].valor == deleted.valor) {
                                abono.metodo_pago.splice(index, 1);
                            }
                        }
                    }
                })

                this.$emit("actualizar", this.datos_de_compradores);
                this.$nextTick(() => {
                    this.show_desglose = true;
                })
            },
            setConfigPlazos() {
                let max_plazos = 1000;
                let min_plazos = 0;
                let frecuencias = null;
                let activar_plazos = true;

                Object.values(this.datos_de_compradores).forEach(abono => {
                    if(abono.area.activar_pago_plazos) {
                        if(abono.area.min_cantidad_plazos > min_plazos) {
                            min_plazos = abono.area.min_cantidad_plazos;
                        }

                        if(abono.area.max_cantidad_plazos < max_plazos) {
                            max_plazos = abono.area.max_cantidad_plazos;
                        }

                        if(frecuencias === null) {
                            frecuencias = abono.area.frecuencias;
                        } else {
                            let items = [];

                            frecuencias.forEach((frecuencia, index) => {
                                if(!abono.area.frecuencias.find(({ id }) => id === frecuencia.id)) {
                                    items.push(index);
                                }
                            })

                            items.forEach(item => {
                                frecuencias.splice(item, 1);
                            })
                        }
                    }
                });

                this.max_plazos = max_plazos;
                this.min_plazos = min_plazos;
                if(activar_plazos) {
                    this.frecuencias = frecuencias;
                }
            },
            resetPlazos() {
                var datos = Object.values(this.datos_compradores);
                datos.forEach(abono => {
                    abono.plazos = false;
                    abono.plazos_pendientes = null;
                });
            },
            solicitarPlazos(data) {
                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro
                    },
                    lista_id: this.$store.getters.getListaId,
                    session_id: this.session_id,
                    frecuencias: data.frecuenciaSelect,
                    n_plazos: data.plazoSelect,
                    datos_compradores: this.datos_de_compradores
                }

                this.$store.dispatch(this.config.getVuexAlias('back.abonos.calcular.plazos'), params).then(res => {
                    this.error_plazos = false;
                    var newDatosCompradores = this.datos_compradores;
                    res.data.datos_compradores.forEach((abono, index) => {
                        newDatosCompradores[index].plazos = abono.plazos;
                        newDatosCompradores[index].plazos_pendientes = abono.plazos_pendientes;
                    });
                    this.$emit('solicitarPlazos', newDatosCompradores);
                    this.enviarDatosCompradores(newDatosCompradores);
                    this.reload += 1;
                }).catch(error => {
                    this.$toast.error('Error al calcular los plazos del abono');
                    this.error_plazos = true;
                });
            },
            enviarDatosCompradores() {
                const params = {
                    "lista_id": this.$store.getters.getListaId,
                    "session_id": this.session_id,
                    "datos_compradores":
                        Object.values(this.datos_de_compradores).map((comprador, index) => {
                            let sessionButacaId;
                            if (this.session_butaca_data ) {
                                sessionButacaId = this.session_butaca_data[index].id;
                            }

                            let abono = {
                                "nombre": comprador.nombre,
                                "apellidos": comprador.apellidos,
                                "email": comprador.email,
                                "genero_id": comprador.genero_id,
                                "dni": comprador.dni,
                                "tipoDocumento": comprador.tipoDocumento,
                                "telefono": comprador.telefono,
                                "fecha_nacimiento": comprador.fecha_nacimiento,
                                "pais": comprador.pais,
                                "provincia": comprador.provincia,
                                "localidad": comprador.localidad,
                                "domicilio": comprador.domicilio,
                                "penista": comprador.penista,
                                "cp": comprador.cp,
                                "es_nuevo": comprador.es_nuevo,
                                "precio": {
                                    "id": comprador.precio.id,
                                    "precio": comprador.precio.precio
                                },
                                "area": {
                                    "id": comprador.area.id,
                                    "descripcion": comprador.area.descripcion,
                                    "precio": comprador.area.precio,
                                    "renovacion": comprador.area.renovacion,
                                    "privacidad": comprador.privacidad,
                                    "condiciones": comprador.condiciones,
                                    "comunicaciones": comprador.comunicaciones
                                },
                                "plazos": comprador.plazos ? comprador.plazos : false,
                                "plazos_pendientes": comprador.plazos_pendientes ? comprador.plazos_pendientes : [],
                                "descuento_aplicado": comprador.descuento_aplicado ? comprador.descuento_aplicado : null,
                                "descuento_integro": comprador.descuento_integro ? comprador.descuento_integro : null,
                                "lista_abonado_session_id": sessionButacaId,
                                "n_abonado_antiguo": comprador.n_abonado_antiguo ? comprador.n_abonado_antiguo : null,
                                "renovacion_automatica": comprador.renovacion_automatica ? comprador.renovacion_automatica : null,
                                "empresa": comprador.empresa ? comprador.empresa : null,
                                "observaciones": comprador.observaciones ? comprador.observaciones : null
                            }

                            if (comprador.plaza && Object.keys(comprador.plaza).length) {
                                abono.plaza = comprador.plaza;
                            } else {
                                abono.asiento = comprador.asiento;
                            }

                            return abono;
                        })
                }

                this.$store.dispatch(this.config.getVuexAlias('back.abonados.guardar-datos-comprador'), params).then(res => {
                    this.datosCompradoresEnviados = true;
                    this.desactivar = true;
                    this.reload += 1;
                }).catch(error => {
                    this.$toast.error('Error al enviar los datos de los compradores');
                    this.error_plazos = true;
                });
            },
            quieresComprarParcelas() {
                this.parcelas = true;
                this.continuar = false;
                this.$scrollTo('body', 1000, {
                    offset: document.body.scrollHeight
                });
            },
            sinParcelas() {
                this.continuar = true;
                this.parcelas = false;
                setTimeout(() => {
                    this.$scrollTo('#finalizar-compra', 500);
                }, 500);
            },
            verPlazos() {
                this.plazos = true;
            },
            fillMetodosPago(metodos_pago) {
                metodos_pago.forEach(metodo_pago => {
                    this.metodos_pago_formatted.push(metodo_pago);
                })
            },
            terminarPasoParcelas() {
                this.parcelasCompradas = true;
                this.continuar = true;
                setTimeout(() => {
                    this.$scrollTo('#finalizar-compra', 500);
                }, 500);
            },
            modificarDatos() {
                if(this.plazosSeleccionados){
                    this.plazosSeleccionados = false;
                    this.resetPlazos();
                }
                this.datosCompradoresEnviados = false;
                this.parcelas = false;
                this.continuar = false;
                this.desactivar = false;
                this.reload += 1;
            },
            cancelarCompraParcelas() {
                this.sinParcelas();

                Object.values(this.datos_de_compradores).forEach(abono => {
                    if (this.parcelasCompradas) {
                        const params = {
                            cart_id: abono.cart_id_parcelas,
                        };

                        this.$store.dispatch(this.config.getVuexAlias('front.parcelas.carrito.borrar'), params).then(res => {
                        }).catch(error => {
                            console.error('Error al eliminar parcela:', error);
                        });
                    }

                });
                this.parcelas = false;
                this.continuar = false;
                this.parcelasCompradas = false;
                this.reload += 1;
            },
            setDatosAbono(abono, index) {
                const asiento = this.datos_de_compradores[index].asiento;
                const plaza = this.datos_de_compradores[index].plaza;
                this.datos_de_compradores[index] = abono;
                this.datos_de_compradores[index].asiento = asiento;
                this.datos_de_compradores[index].plaza = plaza;
            }
        },
        components: {
            TitleComponent, DatosAbonoComponent, DesgloseMetodoPagoAbono, AddPlazosComponent, VentaParcelasAbonos
        }
    }
</script>
<style scoped>
::v-deep .multiselect.is-invalid .multiselect__tags {
    border-color: #dc3545 !important;
}

::v-deep .multiselect.is-invalid .multiselect__tags:focus-within {
    border-color: #dc3545 !important;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
</style>
